import { Check, Languages } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { resolveLocale, SUPPORTED_LOCALES, type SupportedLocale } from '@/i18n';

const labels: Record<SupportedLocale, string> = {
  en: 'English',
  pl: 'Polski',
  fr: 'Français',
  es: 'Español',
  it: 'Italiano',
};

export function LanguageSwitcher() {
  const { i18n, t } = useTranslation('common');
  const active = resolveLocale(i18n.language);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="sm" className="gap-2" aria-label={t('topBar.language')}>
          <Languages className="h-4 w-4" />
          <span className="hidden sm:inline">{labels[active]}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {SUPPORTED_LOCALES.map((locale) => (
          <DropdownMenuItem
            key={locale}
            onSelect={() => void i18n.changeLanguage(locale)}
            className="gap-2"
          >
            {locale === active ? <Check className="h-4 w-4" /> : <span className="h-4 w-4" />}
            {labels[locale]}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
